const MESSAGES: Record<string, string> = {
  invalid_code:
    "That code is incorrect. Try the current code from your authenticator.",
  code_replayed:
    "That code was already used. Wait for the next one and try again.",
  not_authorized: "You are not authorized to charge. Ask a manager to add you.",
  enrollment_required: "Set up your authenticator to continue.",
  already_enrolled:
    "You already have an authenticator set up. Ask a manager to reset it if you need to re-enroll.",
  locked:
    "Too many incorrect codes. Charging is locked for a few minutes — try again shortly.",
  charge_locked:
    "Your charging window expired — unlock again with a fresh code to continue.",
};

export function isTotpError(err: unknown): boolean {
  const raw = (err as any)?.response?.data?.message as string | undefined;
  return !!raw && raw in MESSAGES;
}

export function totpErrorMessage(err: unknown): {
  code: string;
  message: string;
} {
  const raw = (err as any)?.response?.data?.message as string | undefined;
  if (raw && MESSAGES[raw]) return { code: raw, message: MESSAGES[raw] };
  return {
    code: raw ?? "unknown",
    message: "Something went wrong. Please try again.",
  };
}
